export default __webpack_public_path__ + "static/media/office1-after2-2048w.749ec5ac.webp";